import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import { formateExportName, tableExport } from "@/core/helpers/utility";

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    errors: {},
    regions: [],
  }),
  getters: {},
  actions: {
    setError(error) {
      this.errors = { ...error };
    },

    //get
    getEntityDetails(entityId, entityType) {
      return ApiService.get(
        `/v2/Entity/Details?entityId=${entityId}&entityType=${entityType}`
      )
        .then((response) => {
          this.setError({});
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    getERPDetails(entityId, entityType) {
      return ApiService.get(`/v2/Entity/Webhook/${entityId}/${entityType}`)
        .then((response) => {
          this.setError({});
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    updateEntityProfile(data, entityId, entityType) {
      return ApiService.put(`/v2/Entity/Update/${entityId}/${entityType}`, data)
        .then((response) => {
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    updateUserProfile(data) {
      return ApiService.put(`/v2/Account/Update`, data)
        .then((response) => {
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    updateUserPassword(data) {
      //  const {
      //   entityId = "",
      //   type = "",
      //   product,
      //   quantity,
      //   data = { product, quantity },
      // } = requestData ?? {};

      return ApiService.put(`/v2/Account/ChangePassword`, data)
        .then((response) => {
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    testERPConnection(data, entityId, entityType) {
      return ApiService.post(
        `/v2/Entity/TestConnection/${entityId}/${entityType}`,
        data
      )
        .then((response) => {
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },

    updateERPConnection(data, entityId, entityType) {
      return ApiService.post(
        `/v2/Entity/Webhook/${entityId}/${entityType}`,
        data
      )
        .then((response) => {
          return response;
        })
        .catch(({ error }) => {
          this.setError(error?.data?.message);
          throw error;
        });
    },
  },
});
